var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIgnoreCarousel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icIgnoreCarousel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.9061027,34.7919238 L47.2485931,25.4494224 C48.1085806,24.5894339 48.1085806,23.1951207 47.2485931,22.3352552 C46.3886057,21.4752668 44.9944171,21.4752668 44.1344296,22.3352552 L34.7918161,31.6778797 L25.4492027,22.3351322 C24.5892152,21.4751437 23.1950266,21.4751437 22.3350392,22.3351322 C21.4751747,23.1951207 21.4751747,24.5894339 22.3350392,25.4492993 L31.6776527,34.7918008 L22.3350392,44.1344252 C21.4751747,44.9944137 21.4751747,46.3887269 22.3350392,47.2485924 C23.1950266,48.1085808 24.5892152,48.1085808 25.4492027,47.2485924 L34.7918161,37.9059679 L44.1344296,47.2485924 C44.9942941,48.1085808 46.3886057,48.1085808 47.2485931,47.2485924 C48.1085806,46.3886039 48.1085806,44.9944137 47.2485931,44.1344252 L37.9061027,34.7919238 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-2",
    transform: "translate(-25.000000, -1182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icIgnoreCarousel",
    transform: "translate(25.000000, 1182.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,0 C15.7491876,0 0,15.7491876 0,35 C0,54.2508124 15.7491876,70 35,70 C54.2508124,70 70,54.2508124 70,35 C70,15.7491876 54.2508124,0 35,0 Z M35,0.985915493 C53.7063063,0.985915493 69.0140845,16.2936937 69.0140845,35 C69.0140845,53.7063063 53.7063063,69.0140845 35,69.0140845 C16.2936937,69.0140845 0.985915493,53.7063063 0.985915493,35 C0.985915493,16.2936937 16.2936937,0.985915493 35,0.985915493 Z",
    id: "Stroke-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIgnoreCarousel);
export default __webpack_public_path__ + "static/media/icIgnoreCarousel.e861fefbe6d64b0dc5d8fddce6b31a87.svg";
export { ForwardRef as ReactComponent };